import styled from 'styled-components';

const MAX_HEIGHT = '88px';

export const StyledPropertyRowSkeletonPhotoContainer = styled.div`
    display: flex;
    height: ${MAX_HEIGHT};
    align-items: center;
    padding: 0 4px;

    /* bypass the need for text to properly align */
    &:before {
        content: "hidden";
        font-size: 0px;
    }
`;
